<template>
  <div :class="$style.mappingFieldRow">
    <div :class="$style.column">
      <InputValidator
        :class="$style.inputField"
        :config="config"
        @InputValidatorModel="handleChangeListItem"
      />
    </div>
    <div :class="$style.column">
      <DropDown
        attribute="jcAttribute"
        :class="$style.dropdown"
        :errorStyleExceptions="$style.error"
        headerText="select JumpCloud attribute"
        name="application attribute"
        :optionLabelKey="'uiValue'"
        :optionValueKey="'value'"
        :options="getDropDownAttributesValues"
        placeholder="select JumpCloud attribute"
        :value="getJcAttributeUiValue"
        @input="handleChangeListItem"
      />
    </div>
  </div>
</template>

<script>
import { isJSONPath, sortAlphabetically } from 'client/applications/utils/ApplicationUtils';
import { suggested } from 'client/util/Constants/ApplicationConstants';
import DropDown from 'components/FormValidation/DropDown';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'OptionalAttributeField',

  components: {
    DropDown,
    InputValidator,
  },

  mixins: [IdentityManagementMixin],

  props: {
    handleChangeListItem: {
      type: Function,
      required: true,
    },
    listItem: {
      type: Object,
      default: () => ({}),
    },
    valueDynamicComponentProps: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    config() {
      return {
        attribute: 'spAttribute',
        name: 'Optional mappings',
        type: 'text',
        errorStyleExceptions: this.$style.error,
        validate: {
          isJSONPath: true,
        },
        value: this.listItem.spAttribute,
      };
    },

    getDropDownAttributesValues() {
      const emptyOption = {
        uiValue: 'all attributes have been mapped',
        value: 'empty option',
        disabled: true,
      };

      const areOptionsEmpty = (this.valueDynamicComponentProps.dropdownOptions.length === 0);

      let options = [emptyOption];

      if (!areOptionsEmpty) {
        const updatedAttributes = this.valueDynamicComponentProps.dropdownOptions
          .map(attr => ({
            uiValue: attr.category === suggested ? `${attr.uiValue} (suggested)` : attr.uiValue,
            value: attr.attribute,
          }));

        options = sortAlphabetically(updatedAttributes, ['uiValue']);
      }

      return options;
    },

    getJcAttributeUiValue: {
      get() {
        const targetOptAttribute = this.findAttribute(this.listItem.jcAttribute, 'attribute');
        return targetOptAttribute ? targetOptAttribute.uiValue : '';
      },
    },
  },

  beforeMount() {
    isJSONPath(this.$validator);
  },

  methods: {
    /**
     * Returns the attribute object from constants by using key and value as search parameters
     * @param {String} value Value to search for
     * @param {String} key Key Attribute to search in
     * @returns Object
     */
    findAttribute(value, key) {
      return this.getOptionalAttributes.find(attr => attr[key] === value);
    },
  },
};
</script>

<style module>
.column {
  min-width: 50%;
}

.column:last-child {
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 10px;
}

.inputField {
  padding-right: 0.8rem;
}

.mappingFieldRow {
  align-items: flex-start;
}
</style>
